// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bB6J","col":"styles_col__S3aDk","actions":"styles_actions__2pWVF","conflict":"styles_conflict__3_YWw"};